import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import { BRAND_COLOR } from '../../shared/analytics-constants';
import type { FpServiceSlice } from '../../../../types/analytics.types';

type TopSearchesBarProps = {
  categories: FpServiceSlice[];
};

const TITLE = 'Top Searches by Service Category';
const SUBTITLE = 'Where platform search demand is concentrated (all firms)';

export const TopSearchesBar = ({ categories }: TopSearchesBarProps) => {
  if (categories.length === 0 || categories.every((c) => c.count === 0)) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState message="No categorized searches for the selected filters." />
      </ChartContainer>
    );
  }

  const max = Math.max(...categories.map((c) => c.count), 1);

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <div className="space-y-4">
        {categories.map((category) => (
          <div key={category.categoryName} className="flex items-center gap-4">
            <div className="w-44 text-sm text-gray-700 truncate" title={category.categoryName}>
              {category.categoryName}
            </div>
            <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{ width: `${(category.count / max) * 100}%`, backgroundColor: BRAND_COLOR }}
              />
            </div>
            <div className="w-16 text-right text-sm font-medium text-gray-900">
              {category.count.toLocaleString('en-US')}
            </div>
          </div>
        ))}
      </div>
    </ChartContainer>
  );
};
